import { call, put, takeLatest, select } from 'redux-saga/effects'
import { handleApiErrors } from '../../lib/api-errors'
import axiosApi from '../../views/client/axiosClient'

import * as Constants from './constants'
import * as brActions from './actions'

function handleRequest(request) {
  return request
    .then(handleApiErrors)
    .then(function (response) {
      return response.data;
    })
    .then(json => json)
    .catch((error) => { throw error })
}
function handleFileRequest(request) {
  return request
    .then(function (response) {
      return {
        data: response.data
      };
    })
    .catch((error) => { throw error })
}

function listRequestApi(formData) {
  const request = axiosApi().post(
    Constants.LS_TRATHUONG_LIST_API,
    formData
  )

  return handleRequest(request);
}

function* lichSuTraThuongListRequestFlow({ payload }) {
  try {
    // grab the client from our action
    const results = yield call(listRequestApi, payload)

    // dispatch the action with our widgets!
    yield put(brActions.lichSuTraThuongListSuccess(results.data))

  } catch (error) {
    yield put(brActions.lichSuTraThuongListError(error))
  }
}

function lichSuTraThuongRemoveRequestApi(formData) {
  const request = axiosApi().post(
    Constants.LS_TRATHUONG_REMOVE_API,
    formData
  )
  return handleRequest(request);
}

function* lichSuTraThuongRemoveRequestFlow({ payload, callback }) {
  try {
    // grab the client from our action
    const result = yield call(lichSuTraThuongRemoveRequestApi, payload)

    // dispatch the action with our widgets!
    yield put(brActions.lichSuTraThuongRemoveSuccess(result));
    if (typeof callback == 'function') {
      yield call(callback, result.data);
    }
  } catch (error) {
    yield put(brActions.lichSuTraThuongRemoveError(error))
  }
}

function exportXlsRequestApi(formData) {
  const url = `${Constants.LS_TRATHUONG_EXPORT_API  }?Loai=${  formData.Loai != '' ? formData.Loai : 0  }&ObjectId=${  formData.ObjectId  }&TuNgay=${  formData.TuNgay  }&DenNgay=${  formData.DenNgay }&page=${  formData.page  }&per_page=${  formData.per_page  }&Keyword=${  formData.Keyword}`;
  const request = axiosApi().get(
    url,
    {
      responseType: 'blob'
    }
  );

  return handleFileRequest(request);
}
function* lichSuTraThuongExportXlsRequestFlow({ payload, callback }) {
  try {
    // grab the client from our action
    const results = yield call(exportXlsRequestApi, payload)
    // dispatch the action with our widgets!
    yield put(brActions.lichSuTraThuongExportXlsSuccess(results.data))
    if (typeof callback == 'function') {
      yield call(callback, results.data);
    }
  } catch (error) {
    yield put(brActions.lichSuTraThuongExportXlsError(error))
  }
}

function* lichSuTraThuongWatcher() {
  yield [
    takeLatest(Constants.LS_TRATHUONG_LIST_REQUESTING, lichSuTraThuongListRequestFlow),
    takeLatest(Constants.LS_TRATHUONG_REMOVE_REQUESTING, lichSuTraThuongRemoveRequestFlow),
    takeLatest(Constants.LS_TRATHUONG_EXPORT_XLS_REQUESTING, lichSuTraThuongExportXlsRequestFlow),
  ]
}

export default lichSuTraThuongWatcher



// WEBPACK FOOTER //
// ./src/views/LichSuTraThuong/sagas.js